import { createI18n } from 'vue-i18n';
import { clients } from '@/config/clients';

const loadedLanguages = {};

async function loadLocaleMessages(locale) {
  if (!loadedLanguages[locale]) {
    const messages = await import(`@/locales/${locale}.json`);
    loadedLanguages[locale] = messages.default;
  }
  return loadedLanguages[locale];
}

async function getStartingLocale() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('language');

  const theme = document.documentElement.getAttribute('data-theme');
  const version = urlParams.get('version') || clients[theme]?.version || 'v1';
  // Catalan is not supported (v1)
  if (urlLang === 'ca' && version === 'v1') {
    return 'es';
  }

  if (urlLang && (await isValidLocale(urlLang, version))) {
    return urlLang;
  }

  const browserLang = navigator.language.split('-')[0];
  return (await isValidLocale(browserLang, version)) ? browserLang : 'es';
}

const DEV_ONLY_LOCALES = ['fr', 'it', 'pt'];

function isDevEnv() {
  return new URLSearchParams(window.location.search).get('env') === 'dev';
}

async function isValidLocale(locale, version) {
  if (version === 'v2' && DEV_ONLY_LOCALES.includes(locale) && !isDevEnv()) {
    return false;
  }
  if (version === 'v2') {
    return ['es', 'en', 'ca', 'fr', 'it', 'pt'].includes(locale);
  }
  try {
    await import(`@/locales/${locale}.json`);
    return true;
  } catch {
    return false;
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'es', // Default locale
  fallbackLocale: 'es',
  messages: {},
});

async function setLanguage(locale) {
  const messages = await loadLocaleMessages(locale);
  i18n.global.locale.value = locale;
  i18n.global.setLocaleMessage(locale, messages);
  document.documentElement.lang = locale;
}

export { i18n, setLanguage, getStartingLocale };
